module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xartCF/tc-custom/9781488046162.jpg?1726755940100",
      "alt": "This image is the cover for the book Enemy Infiltration, Red, White and Built: Delta Force Deliverance"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Enemy Infiltration, Red, White and Built: Delta Force Deliverance\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("To uncover the truth about her brother’s death overseas, a determined woman will confront any danger—with a jaded Delta Force soldier at her side . . .")]), _c('br'), _c('br'), _vm._v("Strong-willed Lana Moreno won’t rest until she finds out the truth about her heroic brother’s death. And neither will Logan Hess, whose covert government mission soon becomes entwined with another goal: protecting Lana. On Logan’s Texas ranch, these unlikely partners are fighting to understand what really happened overseas while sparks ignite between them. But their investigation quickly provokes a firestorm of consequences—and attention from all the wrong people."), _c('br'), _c('br'), _vm._v("“I recommend this book to anyone looking for a bit of mystery with an intense amount of chemistry between the couple.” —"), _c('i', [_vm._v("Thoughts of a Blonde")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carol Ericson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carol Ericson lives in southern California, home of state-of–the-art cosmetic surgery, wild freeway chases, and a million amazing stories. These stories, along with hordes of virile men and feisty women clamor for release from Carol’s head until she sets them free to fulfill their destinies and her readers’ fantasies. To find out more about Carol and her current books, please visit her website at www.carolericson.com, “where romance flirts with danger.”")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0